import { render, staticRenderFns } from "./AccordionSetsForm.vue?vue&type=template&id=4d1bc6ee&scoped=true&"
import script from "./AccordionSetsForm.vue?vue&type=script&lang=js&"
export * from "./AccordionSetsForm.vue?vue&type=script&lang=js&"
import style0 from "./AccordionSetsForm.vue?vue&type=style&index=0&id=4d1bc6ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1bc6ee",
  null
  
)

export default component.exports